import * as React from "react";

function IcContactMail(props) {
  const {
    accentColor: accent = "#0194F3",
    color = "#687176",
    width = 24,
    height = 24,
    title,
    titleId,
  } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-id="IcContactMail"
      aria-labelledby={titleId}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M4.45711 5.04289C4.06658 4.65237 3.43342 4.65237 3.04289 5.04289C2.65237 5.43342 2.65237 6.06658 3.04289 6.45711L4.45711 5.04289ZM20.9571 6.45711C21.3476 6.06658 21.3476 5.43342 20.9571 5.04289C20.5666 4.65237 19.9334 4.65237 19.5429 5.04289L20.9571 6.45711ZM20.2929 15.7071C20.6834 16.0976 21.3166 16.0976 21.7071 15.7071C22.0976 15.3166 22.0976 14.6834 21.7071 14.2929L20.2929 15.7071ZM2.29289 14.2929C1.90237 14.6834 1.90237 15.3166 2.29289 15.7071C2.68342 16.0976 3.31658 16.0976 3.70711 15.7071L2.29289 14.2929ZM5 6H19V4H5V6ZM20 7V17H22V7H20ZM19 18H5V20H19V18ZM4 17V7H2V17H4ZM3.04289 6.45711L7.29289 10.7071L8.70711 9.29289L4.45711 5.04289L3.04289 6.45711ZM7.29289 10.7071L9.52513 12.9393L10.9393 11.5251L8.70711 9.29289L7.29289 10.7071ZM14.4749 12.9393L16.7071 10.7071L15.2929 9.29289L13.0607 11.5251L14.4749 12.9393ZM16.7071 10.7071L20.9571 6.45711L19.5429 5.04289L15.2929 9.29289L16.7071 10.7071ZM15.2929 10.7071L20.2929 15.7071L21.7071 14.2929L16.7071 9.29289L15.2929 10.7071ZM3.70711 15.7071L8.70711 10.7071L7.29289 9.29289L2.29289 14.2929L3.70711 15.7071ZM5 18C4.44772 18 4 17.5523 4 17H2C2 18.6569 3.34315 20 5 20V18ZM20 17C20 17.5523 19.5523 18 19 18V20C20.6569 20 22 18.6569 22 17H20ZM9.52513 12.9393C10.892 14.3062 13.108 14.3062 14.4749 12.9393L13.0607 11.5251C12.4749 12.1109 11.5251 12.1109 10.9393 11.5251L9.52513 12.9393ZM19 6C19.5523 6 20 6.44772 20 7H22C22 5.34315 20.6569 4 19 4V6ZM5 4C3.34315 4 2 5.34315 2 7H4C4 6.44772 4.44772 6 5 6V4Z"
        fill={color}
      />
    </svg>
  );
}

export default IcContactMail;
